import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';

const RefundRequestsPanel = () => {
  const [refundRequests] = useState([
  {
    id: "REF-2025-001",
    orderId: "ORD-2025-001198",
    customer: {
      name: "David Wilson",
      avatar: "https://images.unsplash.com/photo-1630257202782-ae7fbd64bd02",
      avatarAlt: "Professional headshot of man with beard in gray sweater smiling"
    },
    amount: "$125.00",
    reason: "Service not completed as promised",
    requestedAt: "2 hours ago",
    priority: "high",
    service: "Home Repair"
  },
  {
    id: "REF-2025-002",
    orderId: "ORD-2025-001203",
    customer: {
      name: "Lisa Thompson",
      avatar: "https://images.unsplash.com/photo-1688597628916-d3230d8ac41e",
      avatarAlt: "Professional headshot of woman with blonde hair in black blazer"
    },
    amount: "$67.50",
    reason: "Food quality issues",
    requestedAt: "4 hours ago",
    priority: "medium",
    service: "Food Delivery"
  },
  {
    id: "REF-2025-003",
    orderId: "ORD-2025-001189",
    customer: {
      name: "Robert Garcia",
      avatar: "https://images.unsplash.com/photo-1506017744066-d9d6150e74a4",
      avatarAlt: "Professional headshot of Hispanic man in white dress shirt"
    },
    amount: "$89.99",
    reason: "Provider cancelled last minute",
    requestedAt: "6 hours ago",
    priority: "low",
    service: "Tutoring"
  }]
  );

  const getPriorityColor = (priority) => {
    const colors = {
      high: 'bg-red-100 text-red-800 border-red-200',
      medium: 'bg-amber-100 text-amber-800 border-amber-200',
      low: 'bg-blue-100 text-blue-800 border-blue-200'
    };
    return colors?.[priority] || colors?.low;
  };

  const getPriorityIcon = (priority) => {
    const icons = {
      high: 'AlertTriangle',
      medium: 'Clock',
      low: 'Info'
    };
    return icons?.[priority] || 'Info';
  };

  return (
    <div className="bg-card border border-border rounded-lg">
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-foreground">Recent Refund Requests</h3>
          <Button variant="ghost" size="sm" iconName="ExternalLink">
            View All
          </Button>
        </div>
      </div>
      <div className="divide-y divide-border max-h-96 overflow-y-auto">
        {refundRequests?.map((request) =>
        <div key={request?.id} className="p-4 hover:bg-muted/50 transition-hover">
            {/* Request Header */}
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center space-x-3">
                <Image
                src={request?.customer?.avatar}
                alt={request?.customer?.avatarAlt}
                className="w-8 h-8 rounded-full object-cover" />

                <div>
                  <h4 className="text-sm font-medium text-foreground">{request?.customer?.name}</h4>
                  <p className="text-xs text-muted-foreground">{request?.orderId}</p>
                </div>
              </div>
              <span className={`px-2 py-1 text-xs font-medium rounded-full border flex items-center space-x-1 ${getPriorityColor(request?.priority)}`}>
                <Icon name={getPriorityIcon(request?.priority)} size={12} />
                <span className="capitalize">{request?.priority}</span>
              </span>
            </div>

            {/* Request Details */}
            <div className="space-y-2 mb-3">
              <div className="flex items-center justify-between">
                <span className="text-sm text-muted-foreground">Service:</span>
                <span className="text-sm font-medium text-foreground">{request?.service}</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-sm text-muted-foreground">Amount:</span>
                <span className="text-sm font-medium text-foreground">{request?.amount}</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-sm text-muted-foreground">Requested:</span>
                <span className="text-sm text-muted-foreground">{request?.requestedAt}</span>
              </div>
            </div>

            {/* Reason */}
            <div className="mb-4">
              <p className="text-sm text-muted-foreground mb-1">Reason:</p>
              <p className="text-sm text-foreground bg-muted/50 rounded p-2">{request?.reason}</p>
            </div>

            {/* Actions */}
            <div className="flex items-center space-x-2">
              <Button variant="outline" size="sm" iconName="Check" className="flex-1">
                Approve
              </Button>
              <Button variant="ghost" size="sm" iconName="X" className="flex-1">
                Reject
              </Button>
              <Button variant="ghost" size="icon" className="h-8 w-8">
                <Icon name="MessageSquare" size={14} />
              </Button>
            </div>
          </div>
        )}
      </div>
      {refundRequests?.length === 0 &&
      <div className="p-8 text-center">
          <Icon name="CheckCircle" size={48} className="text-muted-foreground mx-auto mb-4" />
          <p className="text-muted-foreground">No pending refund requests</p>
        </div>
      }
    </div>);

};

export default RefundRequestsPanel;